export class AudioManager extends Phaser.Scene {
  private soundEffectsEnabled: boolean = true;
  private musicEnabled: boolean = true;

  private static instance;

  static getInstance() {
    if (!this.instance) {
      this.instance = new AudioManager(true, false);
    }
    return this.instance;
  }

  private constructor(soundEffectsEnabled, musicEnabled) {
    super('AudioManager');
    this.soundEffectsEnabled = soundEffectsEnabled;
    this.musicEnabled = musicEnabled;
  }

  public isMusicEnabled() {
    return this.musicEnabled;
  }

  public areSoundEffectsEnabled() {
    return this.soundEffectsEnabled;
  }

  public enableMusic() {
    this.musicEnabled = true;
  }

  public disableMusic() {
    this.musicEnabled = false;
  }

  public toggleMusic() {
    if (this.musicEnabled) {
      this.disableMusic();
    } else {
      this.enableMusic();
    }
  }

  public enableSoundEffects() {
    this.soundEffectsEnabled = true;
  }

  public disableSoundEffects() {
    this.soundEffectsEnabled = false;
  }

  public toggleSoundEffects() {
    if (this.soundEffectsEnabled) {
      this.disableSoundEffects();
    } else {
      this.enableSoundEffects();
    }
  }

  public isMusicPlaying(scene, name) {
    const snd = scene.sound.get(name);
    return snd.isPlaying;
  }

  public playSoundEffect(scene, name, volume?: number) {
    if (this.areSoundEffectsEnabled()) {
      let snd = scene.sound.get(name);

      if (!volume) {
        volume = 0.6;
      }

      if (!snd) {
        snd = scene.sound.add(name, { volume });
      }
      snd.play();
    }
  }

  public pauseSoundEffect(scene, name) {
    if (this.areSoundEffectsEnabled()) {
      const snd = scene.sound.get(name);
      snd.pause();
    }
  }

  public resumeSoundEffect(scene, name) {
    if (this.areSoundEffectsEnabled()) {
      const snd = scene.sound.get(name);
      snd.resume();
    }
  }

  public stopSoundEffect(scene, name) {
    if (this.areSoundEffectsEnabled()) {
      const snd = scene.sound.get(name);
      snd.stop();
    }
  }
}
